import styled from 'styled-components';

export const ContainerSkills = styled.div.attrs(() => ({
    className: 'd-flex flex-column'
}))`
    @media (max-width: 991px) {
        justify-content: center;
    }
`;

export const ContainerDivSkills = styled.div.attrs(() => ({
    className: 'd-flex flex-column'
}))``;

export const SpanSkill = styled.span.attrs(() => ({
    className: 'p-1'
}))`
    font-size: 14px;
    font-weight: 500;
`;

export const MainContainer = styled.div.attrs(() => ({
    className: 'd-flex justify-content-around mb-2'
}))`
    @media (max-width: 991px) {
        flex-direction: column;
    }
`;